import { clientVersion } from '@trello/config';
import { parseNetworkError } from '@trello/graphql-error-handling';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { Board_HistoryCardsPerListArgs } from '../generated';

export const boardHistoryResolver = (
  board: {
    id: string;
  },
  args: object,
  context: object,
  info: QueryInfo,
) => {
  return prepareDataForApolloCache(
    {
      id: board.id,
    },
    info,
    'Board',
  );
};

export const getCardsPerList = async (
  board: {
    id: string;
  },
  args: Board_HistoryCardsPerListArgs,
  context: object,
  info: QueryInfo,
) => {
  const queryParams = new URLSearchParams();
  if (args.from) {
    queryParams.set('from', args.from);
  }
  const response = await fetch(
    `/1/boards/${board.id}/history/cardsPerList?${queryParams.toString()}`,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        'X-Trello-Client-Version': clientVersion,
      },
    },
  );
  const json = await response.json();

  // GraphQL doesn't have a map type, so we convert the
  // idList->dataPoints map into a list
  const series = Object.entries(json.series).map(([idList, series]) => {
    return {
      idList,
      dataPoints: series,
    };
  });

  if (response.ok) {
    return prepareDataForApolloCache(
      {
        ...json,
        series,
      },
      info,
      'Board_History',
    );
  }
  throw await parseNetworkError(response);
};
